import Head from 'next/head'

import type { FC, ReactNode } from 'react'
import type { SeoProps } from '@/types'

import { siteConfig } from '@/constants/site'

export const Seo: FC<SeoProps> = ({
    title,
    description,
    ogImage,
    siteName
}): ReactNode => {
    const name = siteName || siteConfig.name
    const pageTitle = title ? `${title} - ${name}` : name
    const pageDescription = description || siteConfig.description

    return (
        <Head>
            <title>
                {pageTitle}
            </title>

            <meta name='description' content={pageDescription} />
            <meta property='og:title' content={pageTitle} />
            <meta property='og:description' content={pageDescription} />
            <meta property='og:site_name' content={name} />
            <meta property='og:type' content='website' />
            <meta property='og:url' content={siteConfig.url} />
            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:title' content={pageTitle} />
            <meta name='twitter:description' content={pageDescription} />

            {ogImage && <meta property='og:image' content={ogImage} />}
            {ogImage && <meta name='twitter:image' content={ogImage} />}
        </Head>
    )
}
